module.exports = __webpack_public_path__ + "media/500_SERF_2022_HackerMotivations.3abf5aad.mp4";